<template>
    <div class="device_detail_card usage_card">
        <div class="device_detail_card_title">
            <span>
                {{ $t('dashboard.device_detail.data_usage.data_package_usage') }}
            </span>
            <TextButton
                :text="$t('dashboard.device_detail.details')"
                @click="showItems.dialog = true"
            />
            <ReoDialog
                v-if="showItems.dialog"
                @cancel="showItems.dialog=false"
                @confirm="showItems.dialog=false"
                :label-of-confirm="$t('dashboard.device_detail.i_know_it')"
            >
                <div class="data_usage_dialog">
                    <p>{{ $t('dashboard.device_detail.data_usage.data_usage_dialog.p1') }}</p>
                    <p>{{ $t('dashboard.device_detail.data_usage.data_usage_dialog.p2') }}</p>
                    <p>{{ $t('dashboard.device_detail.data_usage.data_usage_dialog.p3') }}</p>
                </div>
            </ReoDialog>
        </div>
        <div class="device_detail_card_content">
            <ProgressWithDetails
                :left-description="$t('dashboard.device_detail.data_usage.usage')"
                :tip="$t('dashboard.device_detail.data_usage.usage_tip')"
                :items="progressDetailItems"
            />
            <ReoCommonButton
                :label="$t('dashboard.device_detail.data_usage.usage_detaiL')"
                size="middle"
                @click="$router.push({path: '/user/my-sim/usage/',query:{sub_id: subId ,ymh: $route.query['ymh']}})"
                colorType="light"
                :customWidth="154"
            />
        </div>
    </div>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue';
import ReoDialog from '@/basic/Dialog.vue';
import TextButton from '@/basic/TextButton.vue';
import ProgressWithDetails, { IRawDetailItem } from './ProgressWithDetails.vue';
import { ITrafficData } from '@/lib/simManager';

export default Vue.extend({
    components: {
        ReoDialog,
        ProgressWithDetails,
        TextButton
    },
    props: {
        subId: String,
        trafficData: Object as PropType<ITrafficData>
    },
    data() {

        return {
            showItems: {
                dialog: false,
                more: false
            },
        };

    },
    computed: {
        progressDetailItems(): IRawDetailItem[] {

            return [{
                text: this.$t( 'dashboard.device_detail.data_usage.formal_usage' ).toString(),
                tip: this.$t( 'dashboard.device_detail.data_usage.formal_usage_tip' ).toString(),
                current: this.trafficData.subscriptionTrafficUsed,
                total: this.trafficData.subscriptionTrafficTotal,
                color: 'var(--b_6)',
                isUnlimited: this.trafficData.isUnlimitedMain || this.trafficData.isUnlimitedAddOn
            }, {
                text: this.$t( 'dashboard.device_detail.data_usage.supplement_usage' ).toString(),
                tip: this.$t( 'dashboard.device_detail.data_usage.supplement_usage_tip' ).toString(),
                current: this.trafficData.addOnTrafficUsed,
                total: this.trafficData.addOnTrafficTotal,
                color: 'var(--b_3)',
                isUnlimited: this.trafficData.isUnlimitedAddOn
            }];

        }
    }
});
</script>

<style lang="less" scoped>
.usage_card {
    .reo-card();

    .device_detail_card_title{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 16px 20px;
        border-bottom: 1px solid @line;
        font-size: 20px;
        font-weight: 600;
    }
    .device_detail_card_content {
        display: flex;
        flex-direction: column;
        gap: 24px;
        padding: 32px 20px;

        @media @mobile {
            gap: 12px;
            padding-top: 24px;
        }
    }

    .usage_card_more {
        display: flex;
        flex-direction: column;
        gap: 24px;
        padding: 16px;
        background-color: @bg_02;

        /deep/ .reo-button {
            align-self: flex-start;
        }
    }

    .data_usage_dialog {
        display: flex;
        flex-direction: column;
        gap: 24px;
        text-align: left;

        p {
            font-family: @font_02;
            font-size: 14px;
            font-weight: 500;
            line-height: normal;
            letter-spacing: 0em;
            color: @font_primary;
        }
    }
}

</style>
